import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import LogoLibrary from "@/src/components/LogoLibrary.tsx";
import { useCompanyLogos } from "@/src/hooks/useCompanyLogos.ts";
import { SavingIndicator } from "@/src/components/SavingIndicator.tsx";

const LogoSettings: React.FC = () => {
  const { t } = useTranslation();
  const { savedLogos, addLogo, updateLogo, removeLogo, isSaving } =
    useCompanyLogos();

  return (
    <div className="space-y-8">
      <SavingIndicator isSaving={isSaving} />
      <section className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">
          {t("settings.logoLibrary")}
        </h2>
        <p className="text-sm text-gray-500">
          {t("settings.logoLibraryDescription")}
        </p>

        <div className="overflow-hidden rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
          <LogoLibrary
            logos={savedLogos}
            onAdd={async (logo) => {
              await addLogo(logo);
            }}
            onUpdate={updateLogo}
            onRemove={removeLogo}
          />
        </div>
      </section>
    </div>
  );
};

export const Route = createFileRoute("/settings/logos")({
  component: LogoSettings,
});
